// Module
var code = `<div id="timezoneModal" class="modal-dialog">
	<div class="modal-content">
		<div class="modal-header">
			<h4 class="modal-title">Changing timezone</h4>
		</div>
		<div class="modal-body">
			<p>
				We noticed that your computer is on timezone <span data-bind="text: computerTimezone"></span> which is
				different from the timezone <span data-bind="text: profileTimezone"></span> in your profile.
			</p>
			<p>Your timezone will be automatically updated to <span data-bind="text: computerTimezone"></span>.</p>
		</div>
		<div class="modal-footer">
			<button data-bind="click: function(){ clickedOk(); }" class="btn btn-primary">Ok</button>
		</div>
	</div>
</div>
`;
// Exports
export default code;